import { listTileReducerFactory } from '../../../pillar/dashboard/store/reducers/list-tile.reducerFactory';
import { TileState } from '../../../pillar/dashboard/store/state/TileState';
import * as dashboardActions from '../../../pillar/dashboard/store/actions';
import * as ruleActions from '../actions';
import { ModuleConfiguration } from '../../business-rule.module.config';
import { ModuleListModel } from '../../models/ModuleListModel';
import { ModuleModel } from '../../models/ModuleModel';
import { ModuleState } from '../state/ModuleState';
import { RuleState } from '../state/RuleState';
import { RuleModel } from '../../models/RuleModel';
import { RuleListModel } from '../../models/RuleListModel';

var tileStateReducer = listTileReducerFactory(ModuleConfiguration.moduleName, ModuleListModel, ModuleModel, new TileState<ModuleListModel, ModuleModel>());

export function moduleReducer(state = new ModuleState, action: dashboardActions.Actions<ModuleModel>): ModuleState {
  var selected = state.selected;
  var list = state.list;
  switch (action.type) {
    default:
      return tileStateReducer(state, action) as ModuleState;
  }
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/reducers/module.reducer.ts